import React from 'react';

import { ErrorMessage, HelperMessage, ValidMessage } from '@atlaskit/form';

import { textifyError } from 'src/lib/error';

import FieldLabel from './FieldLabel';

import './Field.css';

const AdditionalMessage = ({ errorMessage, validMessage, helperMessage, warningMessage }) => {
  if (errorMessage) return <ErrorMessage>{textifyError(errorMessage)}</ErrorMessage>;
  if (warningMessage) return <div className="warning-message-under-input"><HelperMessage>{warningMessage}</HelperMessage></div>;
  if (validMessage) return <ValidMessage>{validMessage}</ValidMessage>;
  if (helperMessage) return <HelperMessage>{helperMessage}</HelperMessage>;
  return null;
};

const Field = ({ label, isRequired, children, errorMessage, validMessage, helperMessage, warningMessage }) => (
  <div style={{ marginBottom: 8 }}>
    {label && <FieldLabel style={{ marginBottom: '4px' }} isRequired={isRequired}>
      {label}
    </FieldLabel>}
    {children}
    <AdditionalMessage {...{ errorMessage, warningMessage, validMessage, helperMessage }}/>
  </div>
);

export default Field;
